<script setup>
const props = defineProps({
  class: {
    type: String,
    default: ''
  }
})
</script>
<template>
  <svg 
    :class="props.class"
    viewBox="0 0 46 44" width="17" height="16" xmlns="http://www.w3.org/2000/svg" xml:space="preserve">
    <path
      d="M22.915 0c.794 0 1.516.45 1.869 1.159l5.953 12.063 13.313 1.944a2.09 2.09 0 0 1 1.781 2.062c0 .561-.227 1.099-.628 1.491l-9.631 9.384 2.271 13.253a2.094 2.094 0 0 1-2.054 2.435c-.337 0-.669-.082-.967-.238l-11.907-6.262-11.906 6.259c-.298.156-.63.238-.967.238a2.094 2.094 0 0 1-2.055-2.435l2.272-13.25-9.631-9.384a2.083 2.083 0 0 1 1.153-3.553l13.312-1.947 5.954-12.06A2.087 2.087 0 0 1 22.915 0Z" 
      fill="currentColor"
      />
  </svg>
</template>